module.exports = __webpack_public_path__ + "img/autoasyncgoodssetting.11f1ba39.png";